import {
  Edge,
  Node,
  useEdgesState,
  useNodesState,
  ReactFlowProvider,
} from '@xyflow/react';
import { ReactNode, useEffect } from 'react';
import { NodeModel } from 'src/modules/network-configuration/models/node-model';
import { ProjectJsonData } from 'src/types/project';

type Props = {
  projectJsonData: ProjectJsonData;
  children: ReactNode;
};

/**
 * Mirrors import draft nodes/edges into React Flow so StandardNodeDialogEdit and
 * DialogCustomEdgeEdit can use useReactFlow() like on the canvas.
 */
function ImportWizardFlowSync({ projectJsonData, children }: Props) {
  const [, setNodes] = useNodesState<Node<NodeModel>>(
    projectJsonData.nodes as Node<NodeModel>[],
  );
  const [, setEdges] = useEdgesState<Edge>(projectJsonData.edges);

  useEffect(() => {
    setNodes(projectJsonData.nodes as Node<NodeModel>[]);
    setEdges(projectJsonData.edges);
    // Re-apply when the draft revision changes (single sync signal from import state).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectJsonData.lastChanged]);

  return <>{children}</>;
}

export function ImportWizardFlowBridge({ projectJsonData, children }: Props) {
  return (
    <ReactFlowProvider>
      <ImportWizardFlowSync projectJsonData={projectJsonData}>
        {children}
      </ImportWizardFlowSync>
    </ReactFlowProvider>
  );
}
